// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../build-tools/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../build-tools/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    height: 100%;
}

body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    height: 100%;
}

main {
    height: 100%;
}

#root {
    height: 100%;
}

.msgBlinkAni {
    animation: blink 300ms alternate infinite;
}

@keyframes blink {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(0, 0, 0, 0.1);
}

.img-responsive {
    max-width: 100%;
    height: auto;
    border: 0;
    vertical-align: middle;
    display: flex;
    max-height: 350px;
}

.coaching-anchor .react-swipeable-view-container {
    flex: 1;
}

.visuallyhidden {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
}

.chart {
    width: 100%;
    height: 100%;
    font-family: "Roboto", sans-serif;
    font-style: normal;
}

.arrow_box,
.container {
    position: absolute;
    background: #000;
    border: 2px solid transparent;
    color: #000;
    border-radius: 16px;
    font-weight: 400;
    font-size: 12px;
    padding: 12px 12px 12px 12px;
    transform: translateX(-75px) translateY(-100px);
    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);
}

.task_arrow_box {
    position: absolute;
    background: #000;
    border: 2px solid transparent;
    color: #000;
    border-radius: 16px;
    font-weight: 400;
    font-size: 12px;
    padding: 12px 12px 12px 12px;
    transform: translateX(-120px) translateY(-100px);
    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);
}

.arrow_box_reward {
    position: absolute;
    background: #000;
    border: 2px solid transparent;
    color: #000;
    border-radius: 16px;
    font-weight: 400;
    font-size: 12px;
    padding: 12px 12px 12px 12px;
    transform: translateX(-65px) translateY(-98px);
    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);
}

.arrow_box_reward_dark,
.task_arrow_box_dark,
.arrow_box_dark {
    position: absolute;
    background: #000;
    border: 2px solid transparent;
    color: #000;
    border-radius: 16px;
    font-weight: 400;
    font-size: 12px;
    padding: 12px 12px 12px 12px;
    transform: translateX(-65px) translateY(-45px);
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25);
}

.task_arrow_box_dark {
    transform: translateX(-120px) translateY(-100px);
}

.arrow_box_dark {
    transform: translateX(-75px) translateY(-100px);
}
.main_div {
    margin-bottom: 5px;
}

.arrow_box_value {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
}

.apexcharts-tooltip {
    color: #000;
    background: #fff;
    position: absolute;
}

.chart .apexcharts-tooltip {
    overflow: visible;
}

#chart .apexcharts-tooltip span {
    padding: 5px 0;
    display: inline-block;
}

.tooltip-marker {
    width: 10px;
    padding-left: 2px;
    padding-right: 2px;
    margin-right: 5px;
    border-radius: 2px;
}

#SvgjsLine1043 {
    stroke-width: 2;
}

.apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
    padding: 0;
}

.apexcharts-grid-borders {
    stroke-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,oDAAoD;IACpD,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,+CAA+C;IAC/C,+EAA+E;AACnF;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,gDAAgD;IAChD,+EAA+E;AACnF;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,8CAA8C;IAC9C,+EAA+E;AACnF;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,8CAA8C;IAC9C,wEAAwE;AAC5E;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,+CAA+C;AACnD;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["html {\n    height: 100%;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    height: 100%;\n}\n\nmain {\n    height: 100%;\n}\n\n#root {\n    height: 100%;\n}\n\n.msgBlinkAni {\n    animation: blink 300ms alternate infinite;\n}\n\n@keyframes blink {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n    background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.img-responsive {\n    max-width: 100%;\n    height: auto;\n    border: 0;\n    vertical-align: middle;\n    display: flex;\n    max-height: 350px;\n}\n\n.coaching-anchor .react-swipeable-view-container {\n    flex: 1;\n}\n\n.visuallyhidden {\n    position: absolute;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    width: 1px;\n    margin: -1px;\n    padding: 0;\n    border: 0;\n}\n\n.chart {\n    width: 100%;\n    height: 100%;\n    font-family: \"Roboto\", sans-serif;\n    font-style: normal;\n}\n\n.arrow_box,\n.container {\n    position: absolute;\n    background: #000;\n    border: 2px solid transparent;\n    color: #000;\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 12px;\n    padding: 12px 12px 12px 12px;\n    transform: translateX(-75px) translateY(-100px);\n    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);\n}\n\n.task_arrow_box {\n    position: absolute;\n    background: #000;\n    border: 2px solid transparent;\n    color: #000;\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 12px;\n    padding: 12px 12px 12px 12px;\n    transform: translateX(-120px) translateY(-100px);\n    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);\n}\n\n.arrow_box_reward {\n    position: absolute;\n    background: #000;\n    border: 2px solid transparent;\n    color: #000;\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 12px;\n    padding: 12px 12px 12px 12px;\n    transform: translateX(-65px) translateY(-98px);\n    box-shadow: 0 8px 8px rgba(50, 50, 71, 0.08), 0 8px 16px rgba(50, 50, 71, 0.06);\n}\n\n.arrow_box_reward_dark,\n.task_arrow_box_dark,\n.arrow_box_dark {\n    position: absolute;\n    background: #000;\n    border: 2px solid transparent;\n    color: #000;\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 12px;\n    padding: 12px 12px 12px 12px;\n    transform: translateX(-65px) translateY(-45px);\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.task_arrow_box_dark {\n    transform: translateX(-120px) translateY(-100px);\n}\n\n.arrow_box_dark {\n    transform: translateX(-75px) translateY(-100px);\n}\n.main_div {\n    margin-bottom: 5px;\n}\n\n.arrow_box_value {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 22px;\n}\n\n.apexcharts-tooltip {\n    color: #000;\n    background: #fff;\n    position: absolute;\n}\n\n.chart .apexcharts-tooltip {\n    overflow: visible;\n}\n\n#chart .apexcharts-tooltip span {\n    padding: 5px 0;\n    display: inline-block;\n}\n\n.tooltip-marker {\n    width: 10px;\n    padding-left: 2px;\n    padding-right: 2px;\n    margin-right: 5px;\n    border-radius: 2px;\n}\n\n#SvgjsLine1043 {\n    stroke-width: 2;\n}\n\n.apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\n    padding: 0;\n}\n\n.apexcharts-grid-borders {\n    stroke-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
